import * as React from 'react';
import Spinner from '@mos-front-components/public/es/components/Spinner/Spinner';
import { SPECIAL_VALUE } from '../../../../helpers/address';

interface Suggestion {
  special?: SPECIAL_VALUE;
  visible?: string;
  address: string;
}

function renderSuggestion(suggestion: Suggestion): JSX.Element {
  if (!suggestion.special) return <span>{suggestion.address}</span>;
  switch (suggestion.special) {
    case SPECIAL_VALUE.notFound: {
      return (
        <div className="PguFormSelect_option__disabled">
          {suggestion.visible}
        </div>
      );
    }
    case SPECIAL_VALUE.error: {
      return (
        <div className="PguFormSelect_option__error">{suggestion.visible}</div>
      );
    }
    case SPECIAL_VALUE.retry:
    case SPECIAL_VALUE.switchToManual: {
      return (
        <div className="PguFormSelect_option__link">
          <span className="mos-link">{suggestion.visible}</span>
        </div>
      );
    }
    case SPECIAL_VALUE.loading: {
      return (
        <div className="PguFormSelect_option__loading">
          <Spinner />
        </div>
      );
    }
    default: {
      return <span>{suggestion.visible}</span>;
    }
  }
}

export default renderSuggestion;
